import { create } from 'zustand';

// 'pending' marks the window where useStickyAbVariant (StickyAbVariant.tsx) is
// still resolving the client-side A/B variation. Stateful third parties (Marketo forms2) must not
// load against the throwaway parent variation during this window: the variant
// swap remounts the form, and forms2 does not re-bind onSuccess on a second
// loadForm for the same id, so the form gets stuck on "Please Wait" and the
// success message never shows.
type AbPhase = 'idle' | 'pending' | 'resolved';

interface BuilderVariantState {
  variantId: string;
  setVariantId: (id: string) => void;
  abPhase: AbPhase;
  setAbPhase: (phase: AbPhase) => void;
}

const useBuilderVariantStore = create<BuilderVariantState>(set => ({
  variantId: '',
  setVariantId: (id: string) => set({ variantId: id }),
  abPhase: 'idle',
  setAbPhase: (phase: AbPhase) => set({ abPhase: phase }),
}));

export default useBuilderVariantStore;
